import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  menu: {
    boxSizing: "border-box",
    width: "100%",
    position: "fixed",
    bottom: 0,
    left: 0,
    zIndex: theme.zIndex.dialog + 1,
    padding: theme.spacing.space16,
    paddingBottom: theme.spacing.space32,
    borderRadius: "24px 24px 0 0",
    borderTop: "1px solid #FFF",
    background: "rgba(32, 32, 32, 0.66)",
    boxShadow: "4px 4px 10px 0 rgba(255, 255, 255, 0.25)",
    backdropFilter: "blur(18px)",
    gap: theme.spacing.space24,
    display: "none",
    flexDirection: "column",
    transform: "translateY(100%)",
    transition: "transform 0.3s ease-in-out",
    "&.open": {
      display: "flex",
      transform: "translateY(0)",
      animation: "$slideUp 0.3s ease-in-out",
    },
  },
  icon: {
    fontSize: 24,
    padding: theme.spacing.space8,
    cursor: "pointer",
    "&.active": {
      color: "#EE4E42",
    },
  },
  servicesLogo: {
    width: 95,
    height: 95,
    borderRadius: theme.radius.large,
    boxSizing: "border-box",
    "&.active": {
      border: "3px solid #FFF",
    },
  },
  services: {
    display: "flex",
    overflow: "scroll",
    gap: theme.spacing.space16,
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  menuHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  menuFooter: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing.space16,
  },
  servicesItem: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space8,
    textAlign: "center",
    maxWidth: 95,
  },
  "@keyframes slideUp": {
    from: {
      transform: "translateY(100%)",
    },
    to: {
      transform: "translateY(0)",
    },
  },
  button: {
    padding: `${theme.spacing.space12}px 0 !important`,
  },
  menuHeaderRight: {
    display: "flex",
    gap: theme.spacing.space12,
  },
}));
